import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

/** Barra superior: regresar y cerrar sesión. */
@Component({
    selector: 'app-app-bar',
    templateUrl: './app-bar.component.html',
    styleUrls: ['./app-bar.component.scss'],
})
export class AppBarComponent {

    constructor(
        public router: Router,
        public auth: AuthService,
    ) { }

    logout() {
        this.auth.logOut();
    }

    goBack($event: MouseEvent): void {
        $event.preventDefault();
        window.history.back();
    }
}
